import React from "react";
import AsyncSelect from 'react-select/async';
import { useSelector } from "react-redux";

export default function AddressSelect({
  id,
  addressId,
  onAddressIdChange,
  isVisible = true
}) {
  const options = useSelector(
    state =>
      state?.opportunity?.Addresses?.map(
        ({
          ID,
          Street,
          Suburb,
          State,
          Country,
          Postcode,
          LookupReference,
          SearchReference
        }) => ({
          value: ID,
          lookupReference: LookupReference,
          SearchReference,
          label: [
            Street,
            Suburb,
            State,
            Country,
            Postcode
          ]
            .filter(comp => !!comp)
            .join(", ")
        })
      ) || []
  );
  const filterAddresses = (inputValue) => {
    return options.filter((i) => {
      return i.SearchReference.map(sn => sn.SerialNumber).includes(inputValue.toUpperCase()) ||
      i.label.toLowerCase().includes(inputValue.toLowerCase())
    }
    );
  };
  const loadOptions = (inputValue,callback) => {
      callback(filterAddresses(inputValue));
  };


  const value = options.find(({ value, lookupReference }) => (lookupReference !== null && lookupReference === addressId) || value === addressId) || null;
  
  //Fixes bug:
  //When initially starting new quote, sometimes a reference to an address is sent instead.
  //this reference is saved in backend, but when received by salesforce a new address ID is generated.
  //when then loading this quote, address id from backend matches lookupReference instead.
  //this needs to be updated in FE so the next save updates backend with correct ID value
  if(addressId !== null && value !== null && value.value !== null && addressId !== value.value)
  {
    //trigger onChange with updated ID.
    onAddressIdChange(value.value)
  }

  return (
    <AsyncSelect
      inputId={id}
      styles={{
        container: provided => ({
          ...provided,
          visibility: isVisible ? "visible" : "hidden"
        }),
        menu: provided => ({ ...provided, zIndex: 10 })
      }}
      defaultOptions={options}
      loadOptions={loadOptions}
      value={value}
      onChange={option => onAddressIdChange(option ? option.value : "")}
    />
  );
}
